import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { getAssistantBasename } from '../../utils/assistantUrlUtils';
import { CustomerAssistantChatPage } from '../containers/CustomerAssistant/CustomerAssistantChatPage';
import { CustomerAssistantStarterPage } from '../containers/CustomerAssistant/CustomerAssistantStarterPage';

function CustomerAssistantRouter() {
	const basename = getAssistantBasename();

	return (
		<BrowserRouter basename={basename}>
			<Switch>
				<Route path='/:agentTemplateId/:conversationId'>
					<CustomerAssistantChatPage />
				</Route>
				<Route path='/:agentTemplateId' exact>
					<CustomerAssistantStarterPage />
				</Route>
			</Switch>
		</BrowserRouter>
	);
}

// eslint-disable-next-line import/no-default-export
export default CustomerAssistantRouter;
